module.exports = __webpack_public_path__ + "static/img/partner2.546c8e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner2.png
// module id = pwvE
// module chunks = 1